var _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H3C1.35 0 0 1.35 0 3V11C0 12.65 1.35 14 3 14H4V17C4 17.55 4.45 18 5 18C5.28 18 5.53 17.89 5.71 17.71L9.41 14H15C16.65 14 18 12.65 18 11V3C18 1.35 16.65 0 15 0Z",
    fill: "#61676B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 7,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 7,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.13e2ba4001ea92ea2fc05af79af1dc50.svg";
export { ForwardRef as ReactComponent };